import modals from '../modal'

export default (function() {
  'use strict';

  let teamData;
  let teamModal;
  let teamModalTriggers;
  let teamModalNext;
  let teamModalPrevious;
  const teamGrid = document.querySelector('.team-grid')

  function showTeamDetail(teamUri) {

    const teamMemberDetails = teamData[teamUri]
    const nextPrevDetails = Object.keys(teamData);
    const currentIndex = nextPrevDetails.indexOf(teamUri)
    const teamDetailsContainer = teamModal.element

    const teamMemberScroll = teamDetailsContainer.querySelector('.team-card__info')

    teamMemberScroll.scrollTo(0, 0);
    const nameElem = teamDetailsContainer.querySelector('[data-team-detail-name]')
    const positionTitleElem = teamDetailsContainer.querySelector('[data-team-detail-position-title]')

    const imageElem = teamDetailsContainer.querySelector('[data-team-detail-image]')
    const bioElem = teamDetailsContainer.querySelector('[data-team-detail-bio]')
    const bioFullElem = teamDetailsContainer.querySelector('[data-team-detail-bio-full]')
    const connectElems = teamDetailsContainer.querySelectorAll('[data-team-detail-connect]')

    let prevElem = teamDetailsContainer.querySelector('[data-team-uri-previous]')
    let nextElem = teamDetailsContainer.querySelector('[data-team-uri-next]')

    nameElem.innerHTML = teamMemberDetails.name
    positionTitleElem.innerHTML = teamMemberDetails.position_title

    imageElem.src = teamMemberDetails.image.sizes['custom-size']
    imageElem.alt = teamMemberDetails.image.alt

    bioElem.innerHTML = teamMemberDetails.bio
    bioFullElem.innerHTML = teamMemberDetails.bio_full

    connectElems.forEach((connect) => {
      connect.href = teamMemberDetails.connect
    })

   // Get the details of the next person
   if(currentIndex === nextPrevDetails.length - 1){
    let nextPersonName = nextPrevDetails[0];
    nextElem.setAttribute('data-team-uri-next', nextPersonName);
   } else {
    let nextPersonName = nextPrevDetails[currentIndex+1];
    nextElem.setAttribute('data-team-uri-next', nextPersonName);
   }
    if(currentIndex === 0){
      let end = nextPrevDetails.length
      let prevPersonName = nextPrevDetails[end-1];
      prevElem.setAttribute('data-team-uri-previous', prevPersonName);
    } else {
      let prevPersonName = nextPrevDetails[currentIndex - 1];
      prevElem.setAttribute('data-team-uri-previous', prevPersonName);
    }

  }

  function clearTeamDetail() {
    const teamDetailsContainer = teamModal.element

    const teamMemberScroll = teamDetailsContainer.querySelector('.team-card__info')

    teamMemberScroll.scrollTo(0, 0);
    const positionTitleElem = teamDetailsContainer.querySelector('[data-team-detail-position-title]')
    const nameElem = teamDetailsContainer.querySelector('[data-team-detail-name]')
    const imageElem = teamDetailsContainer.querySelector('[data-team-detail-image]')
    const bioElem = teamDetailsContainer.querySelector('[data-team-detail-bio]')
    const bioFullElem = teamDetailsContainer.querySelector('[data-team-detail-bio-full]')
    const connectElems = teamDetailsContainer.querySelectorAll('[data-team-detail-connect]')

    positionTitleElem.innerHTML = ''
    nameElem.innerHTML = ''
    imageElem.innerHTML = ''
    bioElem.innerHTML = ''
    bioFullElem.innerHTML = ''
    imageElem.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

    connectElems.forEach((connect) => {
      connect.href = ''
    })
  }

  function handleTeamTriggerClick(event) {
    event.preventDefault()

    showTeamDetail(event.target.dataset.teamUri)
    teamModal.open(event.target)
  }

  function setupTeamGrid() {
    teamData = JSON.parse(document.getElementById('TeamMemberData').textContent.trim())

    Object.keys(teamData).forEach(function(key) {
      preloadImage(teamData[key].image.sizes['custom-size'])
    })

    teamModalTriggers = [...teamGrid.querySelectorAll('.js-team-detail-trigger')]
    teamModal = modals.getById('modal-team-detail')
    teamModalNext = document.querySelector('.js-team-next')
    teamModalPrevious = document.querySelector('.js-team-previous')

    teamModalTriggers.forEach((trigger) => {
      trigger.addEventListener('click', handleTeamTriggerClick)
    })

    teamModalPrevious.addEventListener('click', handlePreviousMemberClick)
    teamModalNext.addEventListener('click', handleNextMemberClick)

    teamModal.element.addEventListener('close', handleModalClose)

  }

  function handleModalClose() {
    clearTeamDetail()
  }

  function handleNextMemberClick(event, teamUri){
    event.preventDefault()
    document.querySelector('.modal-team-detail').scrollTo(0, 0);
    showTeamDetail(event.target.dataset.teamUriNext)
  }

  function handlePreviousMemberClick(event, teamUri){
    event.preventDefault()

    showTeamDetail(event.target.dataset.teamUriPrevious)
  }

  function preloadImage(url) {
    var img = new Image();
    img.src = url;
  }

  function init() {
    if (!teamGrid) {
      return;
    }

    window.addEventListener('DOMContentLoaded', () => {
      setupTeamGrid()
    })
  }

  return {
    init,
  }

})();
